"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.industriesSubMenu = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
const industriesSubMenu = exports.industriesSubMenu = [{
  path: '/industries/list',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/master/industries/list.vue'))),
  name: 'Industries',
  meta: {
    title: 'master.industries.title',
    noCache: true,
    icon: 'form'
  }
}, {
  path: '/industries/add',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/master/industries/manage.vue'))),
  name: 'Add industries',
  props: {
    isEdit: false
  },
  meta: {
    title: 'master.industries.manage',
    noCache: true,
    activeMenu: '/industries/list',
    hidden: true
  }
}, {
  path: '/industries/edit/:id(\\d+)',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/master/industries/manage.vue'))),
  name: 'Edit Industries',
  props: {
    isEdit: true
  },
  meta: {
    title: 'master.industries.manage',
    noCache: true,
    activeMenu: '/industries/list',
    hidden: true
  }
}];